var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"block"},[_c('img',{attrs:{"src":_vm.blockImg2x,"srcset":_vm.getBlockSrcSet,"alt":"图片"}})])}
var staticRenderFns = []

export { render, staticRenderFns }